export enum EPriority {
    HIGHEST = 1,
    HIGH,
    NORMAL,
    LOW,
    LOWEST,
}
